import React, { useState } from 'react'
import { Routes, Route, BrowserRouter, Navigate, useNavigate, useLocation, Outlet } from "react-router-dom";
import { Layout, Flex, Avatar, Menu, ConfigProvider, Button, Drawer, Divider } from 'antd'
import { LeftOutlined, MenuOutlined } from '@ant-design/icons'
import LOGO from './img/acq-ret.png'
import LOGO_MINI from './img/acq-logo.png'



import Home from './paginas/home';
import Galeria from './paginas/galeria';
import QuemSomos from './paginas/quemSomos';
import Eventos from './paginas/eventos';
import Noticias from './paginas/noticias';
import { isDesktop, isMobile } from 'react-device-detect';




const OutletACQ = () => {

    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const [current, setCurrent] = useState('mail');
    const onClick = e => {
        setOpen(false)
        console.log('click ', e);
        setCurrent(e.key);
        navigate(e.key)
    };

    const items = [
        {
            label: 'Home',
            key: 'home',
        },
        {
            label: 'Membros',
            key: 'quem-somos',
        },
        {
            label: 'Eventos',
            key: 'eventos',
        },
         {
            label: 'Notícias',
            key: 'noticias',
        },
        {
            label: 'Galeria',
            key: 'galeria',
        },
    ]



    return <Layout style={{ width: '100%' }}>
        <Layout.Header style={{
            backgroundColor: '#0098d0',
            display: 'flex',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            width: '100%',
            alignItems: 'center',
        }}>
            <Flex gap={20} align='center'>
                {isMobile && <MenuOutlined style={{ color: 'white' }} onClick={() => setOpen(true)} />}
                <img src={LOGO} height={45} onClick={() => navigate('/')} />
                <ConfigProvider
                    theme={{
                        token: {
                            "colorPrimary": "white",
                            "fontSize": 14,
                        },
                        components: {
                            Menu: {
                                itemColor: 'white',
                                colorPrimary: 'white',
                                colorBorder: 'white',
                                colorInfoText: 'white',
                                colorText: 'white'
                            },
                        },
                    }}
                >
                    {isDesktop && <Menu
                        style={{ backgroundColor: 'transparent', width: 450 }}
                        onClick={onClick}
                        selectedKeys={[current]}
                        mode="horizontal"
                        items={items} />}
                </ConfigProvider>
            </Flex>
        </Layout.Header>
        <Layout.Content>
            <Outlet />
        </Layout.Content>
        <Layout.Footer style={{ backgroundColor: "#0098d0", color: 'white' }}>
            {isDesktop ? <Flex style={{ margin: 30 }} gap={30}>
                <Flex flex={2}>
                    <Flex gap={10}>
                        <Flex><Avatar src={LOGO_MINI} style={{ backgroundColor: 'whitesmoke' }} size={80} shape='square' /></Flex>
                        <Flex vertical>
                            <Flex style={{ fontSize: '1.1em', fontWeight: 600 }}>Academia Cearense de Química </Flex>
                            <span>envidar esforços no sentido de incentivar o desenvolvimento da Ciência e da Indústria Química, particularmente no Estado do Ceará</span>

                        </Flex>
                    </Flex>
                </Flex>
                <Flex flex={2} vertical style={{ marginTop: 0 }} align='center'>
                    <Flex vertical justify='flex-start' align='flex-start'>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/")}>HOME</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/quem-somos")}>QUEM SOMOS</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/eventos")}>EVENTOS</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/noticias")}>NOTÍCIAS</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/galeria")}>GALERIA</Button>
                    </Flex>
                </Flex>
                <Flex flex={1} vertical>
                    <Flex><b>CONTATO</b></Flex>
                    <Flex vertical>
                        <span>Rua Floriano peixo 2020</span>
                        <span>José Bonifacio, Fortaleza-CE</span>
                        <span>60021-020</span>
                        <span>+55 (85) 3226-4958 / 3253-1607 </span>
                        <span>acq@acq.org.br</span>
                    </Flex>
                </Flex>
            </Flex> :
                <Flex vertical gap={10}>
                    <Flex gap={10}>
                        <Flex>
                            <Avatar src={LOGO_MINI} style={{ backgroundColor: 'whitesmoke', marginTop: 5 }} size={40} shape='square' /></Flex>
                        <Flex vertical>
                            <Flex style={{ fontSize: '1.1em', fontWeight: 600 }}>Academia Cearense de Química </Flex>
                            <span>Envidar esforços no sentido de incentivar o desenvolvimento da Ciência e da Indústria Química, particularmente no Estado do Ceará</span>

                        </Flex>
                    </Flex>
                    <Divider />

                    <Flex justify='flex-start' align='flex-start' style={{ fontSize: '0.9em', marginLeft: -20 }}>
                       <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/")}>HOME</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/quem-somos")}>QUEM SOMOS</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/eventos")}>EVENTOS</Button>
                        <Button size='small' type='link' style={{ color: 'white' }} onClick={()=>navigate("/galeria")}>GALERIA</Button>
                    </Flex>

                    <Divider />

                    <Flex flex={1} vertical>
                        <Flex><b>CONTATO</b></Flex>
                        <Flex vertical>
                            <span>Rua Floriano peixo 2020</span>
                            <span>José Bonifacio, Fortaleza-CE</span>
                            <span>60021-020</span>
                            <span>+55 (85) 3226-4958 / 3253-1607 </span>
                            <span>acq@acq.org.br</span>
                        </Flex>
                    </Flex>

                </Flex>
            }
        </Layout.Footer>

        {
            <Drawer
                placement='left'
                width={'50%'}
                open={open}
                onClose={() => setOpen(false)}
                title={<img src={LOGO} height={20} />}
                footer={null}
                closeIcon={<LeftOutlined style={{ color: '#0098d0', fontSize: '1.1em' }} />}>

                <Menu
                    style={{ backgroundColor: 'transparent', width: '100%' }}
                    onClick={onClick}
                    selectedKeys={[current]}
                    mode="vertical"
                    items={items} />

            </Drawer>
        }

    </Layout>
}






function Rotas() {
    return <BrowserRouter>
        <div className="App">
            <Routes>
                <Route path='/' element={<OutletACQ />} >
                    <Route path="/galeria" element={<Galeria />} />
                    <Route path="/quem-somos" element={<QuemSomos />} />
                    <Route path="/eventos" element={<Eventos />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/noticias" element={<Noticias />} />
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<Home />} />
                </Route>


            </Routes>
        </div>
    </BrowserRouter>
}


export default Rotas